var _circle, _path, _path2, _mask, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 11.9998,
    r: 9.5,
    stroke: "#E34850"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.167 7.91895C10.167 7.22859 10.7266 6.66895 11.417 6.66895H12.5837C13.274 6.66895 13.8337 7.22859 13.8337 7.91895V8.58561H10.167V7.91895Z",
    stroke: "#E34850"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.625 8.21069H12H16.375",
    stroke: "#E34850",
    strokeLinecap: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_3151_8772",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.91699 8.5022H16.0837L15.1086 16.3026C14.9991 17.1783 14.2547 17.8355 13.3721 17.8355H10.6285C9.74596 17.8355 9.00151 17.1783 8.89204 16.3026L7.91699 8.5022Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91699 8.5022V7.5022H6.78421L6.92471 8.62623L7.91699 8.5022ZM16.0837 8.5022L17.0759 8.62623L17.2164 7.5022H16.0837V8.5022ZM7.91699 9.5022H16.0837V7.5022H7.91699V9.5022ZM15.0914 8.37816L14.1163 16.1786L16.1009 16.4266L17.0759 8.62623L15.0914 8.37816ZM13.3721 16.8355H10.6285V18.8355H13.3721V16.8355ZM9.88432 16.1786L8.90927 8.37816L6.92471 8.62623L7.89976 16.4266L9.88432 16.1786ZM10.6285 16.8355C10.2503 16.8355 9.93123 16.5539 9.88432 16.1786L7.89976 16.4266C8.07179 17.8028 9.24164 18.8355 10.6285 18.8355V16.8355ZM14.1163 16.1786C14.0694 16.5539 13.7504 16.8355 13.3721 16.8355V18.8355C14.759 18.8355 15.9289 17.8028 16.1009 16.4266L14.1163 16.1786Z",
    fill: "#E34850",
    mask: "url(#path-4-inside-1_3151_8772)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleted);
export default __webpack_public_path__ + "static/media/deleted.74ee9b0b9271dbeceb61f9bb9ef1b39e.svg";
export { ForwardRef as ReactComponent };